import { Mail, Phone, MapPin, ArrowUpRight, ArrowUp, Send } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const socialLinks = [
  {
    label: 'X (Twitter)',
    href: '#',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.258 5.63 5.906-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: '#',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: 'GitHub',
    href: '#',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
      </svg>
    ),
  },
  {
    label: 'Dribbble',
    href: '#',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12 24C5.385 24 0 18.615 0 12S5.385 0 12 0s12 5.385 12 12-5.385 12-12 12zm10.12-10.358c-.35-.11-3.17-.953-6.384-.438 1.34 3.684 1.887 6.684 1.992 7.308 2.3-1.555 3.936-4.02 4.395-6.87zm-6.115 7.808c-.153-.9-.75-4.032-2.19-7.77l-.066.02c-5.79 2.015-7.86 6.017-8.04 6.4 1.73 1.358 3.92 2.166 6.29 2.166 1.42 0 2.77-.29 4-.814zm-11.62-2.58c.232-.4 3.045-5.055 8.332-6.765.135-.045.27-.084.405-.12-.26-.585-.54-1.167-.832-1.74C7.17 11.775 2.206 11.71 1.756 11.7l-.004.312c0 2.633.998 5.037 2.634 6.838zm-2.42-8.955c.46.008 4.683.026 9.477-1.248-1.698-3.018-3.53-5.558-3.8-5.928-2.868 1.35-5.01 3.99-5.676 7.176zM9.6 2.052c.282.38 2.145 2.914 3.822 6 3.645-1.365 5.19-3.44 5.373-3.702-1.81-1.61-4.19-2.586-6.795-2.586-.825 0-1.63.1-2.4.285zm10.335 3.483c-.218.29-1.935 2.493-5.724 4.04.24.49.47.985.68 1.486.08.18.15.36.22.53 3.41-.43 6.8.26 7.14.33-.02-2.42-.88-4.64-2.31-6.38z" />
      </svg>
    ),
  },
];

const services: { label: string; to: string }[] = [
  { label: 'Business Websites', to: '/services' },
  { label: 'E-Commerce', to: '/services' },
  { label: 'SaaS Platforms', to: '/services/saas-development' },
  { label: 'CRM Systems', to: '/services/crm-development' },
  { label: 'CMS Platforms', to: '/services' },
  { label: 'LMS Solutions', to: '/services/lms-development' },
  { label: 'ERP Systems', to: '/services/erp-development' },
  { label: 'GMB Services', to: '/google-my-business-services' },
];

const companyLinks = [
  { label: 'About Us', to: '/about' },
  { label: 'Portfolio', to: '/portfolio' },
  { label: 'Services', to: '/services' },
  { label: 'Contact', to: '/contact' },
];

export default function Footer() {
  const currentYear = 2021;
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer className="relative bg-gray-950 text-gray-400 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[1px] bg-gradient-to-r from-transparent via-emerald-500/40 to-transparent" />
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-emerald-500/4 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-teal-500/3 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" />
      </div>

      <div className="relative container-narrow">
        <div className="py-16 border-b border-gray-800/50">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-500 mb-3">Stay in the loop</p>
              <h3 className="text-2xl font-bold text-white leading-snug mb-2">
                Get insights on digital innovation
              </h3>
              <p className="text-sm text-gray-500 max-w-sm">
                Join 2,000+ founders and CTOs who receive our monthly digest on web, product, and growth.
              </p>
            </div>
            <div>
              {subscribed ? (
                <div className="flex items-center gap-3 py-4 px-5 bg-emerald-600/10 border border-emerald-500/20 rounded-xl">
                  <div className="w-8 h-8 bg-emerald-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-emerald-400">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <p className="text-sm text-emerald-400 font-medium">You're subscribed! Welcome aboard.</p>
                </div>
              ) : (
                <form onSubmit={handleSubscribe} className="flex gap-3">
                  <div className="flex-1 relative">
                    <input
                      type="email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      placeholder="Enter your email address"
                      required
                      className="w-full bg-gray-900 border border-gray-800 text-gray-300 placeholder-gray-600 text-sm rounded-xl px-4 py-3 focus:outline-none focus:border-emerald-500/50 focus:ring-1 focus:ring-emerald-500/20 transition-all duration-300"
                    />
                  </div>
                  <button
                    type="submit"
                    className="flex items-center gap-2 px-5 py-3 bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-semibold rounded-xl transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-emerald-900/40 hover:shadow-emerald-900/60 flex-shrink-0"
                  >
                    Subscribe
                    <Send size={13} />
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 py-16">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-6 group w-fit" aria-label="Matchless Digital Hub — Home">
              <div className="w-11 h-11 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg shadow-emerald-500/25 group-hover:shadow-emerald-500/40 transition-all duration-300">
                <span className="text-white font-bold text-xl tracking-tight">M</span>
              </div>
              <div>
                <span className="block text-white font-bold text-base leading-tight">Matchless Digital Hub</span>
                <span className="block text-[10px] font-semibold text-gray-500 uppercase tracking-[0.2em] leading-tight">Digital Development Agency</span>
              </div>
            </Link>

            <p className="text-sm text-gray-500 leading-relaxed mb-8 max-w-xs">
              Delivering industry-grade digital solutions that transform businesses and drive measurable growth worldwide.
            </p>

            <div className="flex gap-2.5 mb-8">
              {socialLinks.map(social => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center text-gray-500 hover:bg-emerald-600/15 hover:text-emerald-400 transition-all duration-300 border border-gray-800 hover:border-emerald-500/30 hover:-translate-y-0.5"
                >
                  {social.icon}
                </a>
              ))}
            </div>

            <div className="flex items-center gap-2.5">
              <span className="w-2 h-2 rounded-full bg-emerald-500 shadow-[0_0_8px_2px_rgba(16,185,129,0.5)] animate-pulse" />
              <span className="text-xs text-gray-500">Available for new projects</span>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-6 text-xs uppercase tracking-widest">Services</h4>
            <ul className="space-y-2.5">
              {services.map(service => (
                <li key={service.label}>
                  <Link
                    to={service.to}
                    className="group flex items-center gap-1.5 text-sm text-gray-500 hover:text-emerald-400 transition-all duration-200"
                  >
                    <span className="w-0 group-hover:w-3 overflow-hidden transition-all duration-200 text-emerald-500 flex-shrink-0">›</span>
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-6 text-xs uppercase tracking-widest">Company</h4>
            <ul className="space-y-2.5">
              {companyLinks.map(link => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="group flex items-center gap-1.5 text-sm text-gray-500 hover:text-emerald-400 transition-all duration-200"
                  >
                    <span className="w-0 group-hover:w-3 overflow-hidden transition-all duration-200 text-emerald-500 flex-shrink-0">›</span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <h4 className="text-white font-semibold mb-4 text-xs uppercase tracking-widest">Legal</h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'Privacy Policy', to: '/privacy-policy' },
                  { label: 'Terms & Conditions', to: '/terms-and-conditions' },
                ].map(item => (
                  <li key={item.label}>
                    <Link to={item.to} className="group flex items-center gap-1.5 text-sm text-gray-500 hover:text-emerald-400 transition-all duration-200">
                      <span className="w-0 group-hover:w-3 overflow-hidden transition-all duration-200 text-emerald-500 flex-shrink-0">›</span>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-white font-semibold mb-6 text-xs uppercase tracking-widest">Get in Touch</h4>
            <div className="space-y-4 mb-8">
              <a
                href="mailto:hello@matchlessdigitalhub.com"
                className="flex items-center gap-4 group p-3 rounded-xl bg-gray-900/0 hover:bg-gray-900/80 border border-transparent hover:border-gray-800/60 transition-all duration-300"
              >
                <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600/15 group-hover:border-emerald-500/30 border border-gray-800 transition-all duration-300">
                  <Mail size={14} className="text-gray-500 group-hover:text-emerald-400 transition-colors duration-300" />
                </div>
                <div>
                  <div className="text-[11px] text-gray-500 mb-0.5 font-medium uppercase tracking-wider">Email</div>
                  <span className="text-sm text-gray-400 group-hover:text-emerald-400 transition-colors duration-200">hello@matchlessdigitalhub.com</span>
                </div>
              </a>

              <a
                href="tel:+919113499827"
                className="flex items-center gap-4 group p-3 rounded-xl bg-gray-900/0 hover:bg-gray-900/80 border border-transparent hover:border-gray-800/60 transition-all duration-300"
              >
                <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600/15 group-hover:border-emerald-500/30 border border-gray-800 transition-all duration-300">
                  <Phone size={14} className="text-gray-500 group-hover:text-emerald-400 transition-colors duration-300" />
                </div>
                <div>
                  <div className="text-[11px] text-gray-500 mb-0.5 font-medium uppercase tracking-wider">Phone / WhatsApp</div>
                  <span className="text-sm text-gray-400 group-hover:text-emerald-400 transition-colors duration-200">+91 91134 99827</span>
                </div>
              </a>

              <div className="flex items-center gap-4 p-3">
                <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0 border border-gray-800">
                  <MapPin size={14} className="text-gray-500" />
                </div>
                <div>
                  <div className="text-[11px] text-gray-500 mb-0.5 font-medium uppercase tracking-wider">Office</div>
                  <span className="text-sm text-gray-400">Patna, Bihar, India · Remote Worldwide</span>
                </div>
              </div>
            </div>

            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-sm font-semibold rounded-xl hover:from-emerald-500 hover:to-teal-500 transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-emerald-900/40"
            >
              Start a Project
              <ArrowUpRight size={15} />
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-800/50 py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            &copy; {currentYear} Matchless Digital Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-gray-500">Crafted with precision &amp; care</span>
            <div className="w-px h-4 bg-gray-800" />
            <button
              onClick={scrollToTop}
              className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center text-gray-500 hover:bg-emerald-600/15 hover:text-emerald-400 transition-all duration-300 border border-gray-800 hover:border-emerald-500/30 hover:-translate-y-0.5"
              aria-label="Back to top"
            >
              <ArrowUp size={13} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
